import {ReactNode} from 'react';
import {Card, CardContent} from '@nlabs/gothamjs';

import {card, cardBody, cardContent, cardIcon, cardTitle} from '../lib/styles';

export const ServiceCard = ({body, icon, title}: {body: string; icon?: ReactNode; title: string}) => (
  <Card className={`nx-card ${card}`}>
    <CardContent className={cardContent}>
      <span className={`nx-card-icon ${cardIcon}`} aria-hidden="true">{icon}</span>
      <h3 className={cardTitle}>{title}</h3>
      <p className={cardBody}>{body}</p>
    </CardContent>
  </Card>
);
